export interface CoverProps<File = string> {
  getFile: (file: File) => string | null;
  fileName: File;
  name?: string;
}

export const Cover = <File,>({ getFile, fileName, name }: CoverProps<File>) => {
  return (
    <div style={{ position: "relative" }}>
      <img
        style={{
          height: "100%",
          paddingTop: "2%",
          width: "100%",
          minHeight: "200px",
          minWidth: "300px",
        }}
        src={getFile(fileName) ?? undefined}
        title={name}
        alt={name}
      />
    </div>
  );
};
